import React, { useState,useEffect } from 'react';
import { setYearList,setMonthList,setDateRange,formatDate,DownloadFile } from './Function';
import { Container,Row,Col,Card,Table,Form,Placeholder,Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const Manual = () => 
{
    const { t } = useTranslation();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Miscellaneous,setMiscellaneous]=useState([]);
    const[keyword, setKeyword] = useState('');
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const KeywordChange = (e) => setKeyword(e.target.value.trim() || '');
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    useEffect(()=>
    {
        const MiscellaneousByType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/manualAll");
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFileHi")
                                .then(upph => upph.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp,upph]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upph
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscFile = el.upp;
                            result[i].miscFileHi = el.upph;                            
                        });
                        setMiscellaneous(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('Miscellaneous File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setMiscellaneous([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousByType : Result',result); }
            } catch (error) 
            {
                console.error('MiscellaneousByType : Error', error.message);
                setLoading(false);
            }
        };
        MiscellaneousByType();
    },[])
    const MiscellaneousByTypeSearch = async (e) => 
    {
        e.preventDefault();
        if(!keyword && year===0 && month===0)
        {
            alert( appLanguage === "hi" ? "कृपया कम से कम एक कीवर्ड, वर्ष या महीना चुनें!" : "Please Select atleast one Keyword, Year or Month!" );
            return;
        }
        try 
        {
            setLoading(true);
            const { startDate, endDate } = setDateRange(year, month, 1, 0, 0);
            var apiSwitch = (!keyword) ? "miscellaneous/manualBySearch/" : "miscellaneous/manualBySearchWithKeyword/"+keyword+"/";
            const response = await fetch(global.config.API_URL+apiSwitch+startDate+"/"+endDate);
            const result = await response.json();
            if(result.length > 0 )
            {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFile")
                            .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFileHi")
                            .then(upph => upph.json());
                        return Promise.all([fetch1, fetch2])
                            .then(([upp,upph]) => {
                                return {
                                    ...e,
                                    upp,
                                    upph
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].miscFile = el.upp;
                        result[i].miscFileHi = el.upph;                            
                    });
                    setMiscellaneous(result);
                    setLoading(false);
                }).catch(error => {
                    console.error('Miscellaneous File :', error);
                    setLoading(false);
                });
            }
            else
            {
                setMiscellaneous([]);
                setLoading(false);
            }
            if( global.config.IsPrint === true ) { console.info('MiscellaneousByTypeSearch : Result',result); }
        }
        catch (error) { console.error('MiscellaneousByTypeSearch : Error', error.message); }
    };
    return (
        <Container className='py-3 py-md-5'>
            <Card className='mb-4'>
                <Card.Header className='text-center fs-3 text-uppercase'>
                    {appLanguage === 'hi' ? 'सूचना के अधिकार के लिए नियमावली' : 'MANUALS FOR RIGHT TO INFORMATION'}
                </Card.Header>
                <Card.Body>
                    <Card className=' mb-3'>
                        <Card.Body>
                            <form onSubmit={MiscellaneousByTypeSearch}>
                            <div className='mb-2 fw-bold'>{appLanguage === 'hi' ? 'खोजें' : 'SEARCH'}</div>
                            <Row className='g-2'>
                                <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Control type="text" placeholder={appLanguage === 'hi' ? 'शीर्षक/विषय के आधार पर खोजें' : 'Search by Title/Subject'} onChange={KeywordChange} value={keyword} />
                                </Col>
                                <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Select onChange={YearChange} value={year}>
                                        <option value={0}>{appLanguage === 'hi' ? 'वर्ष' : 'Year'}</option>
                                        {setYearList(1,0).map((year) => (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Select onChange={MonthChange} value={month}>
                                        <option value={0}>{appLanguage === 'hi' ? 'महीना' : 'Month'}</option>
                                        {setMonthList().map(({ value, label }) => (
                                        <option key={value} value={value}>
                                            {label}
                                        </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md={3} className='d-grid' data-aos="fade-left" data-aos-duration="1000">
                                    <Button className='btn btn-info' type='submit'><i className="bi bi-search"></i> {appLanguage === 'hi' ? 'खोजें' : 'SEARCH'}</Button>
                                </Col>
                            </Row>
                            </form>
                        </Card.Body>
                    </Card>
                    <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                        <thead>
                            <tr>
                                <th className="w-50">{appLanguage === 'hi' ? 'शीर्षक' : 'Title'}</th>                                
                                <th>{appLanguage === 'hi' ? 'अपलोड की तिथि' : 'Date of Upload'}</th>
                                <th>{appLanguage === 'hi' ? 'डाउनलोड' : 'Download'}</th>                           
                            </tr>
                        </thead>
                        {isLoading ? (
                        <tbody>
                            {[...Array(10)].map((_,index)=>(
                            <tr key={index}>
                                <th className="table-success w-50"><Placeholder xs={10} /></th>
                                <td className="text-center"><Button className="btn btn-light w-75"><Placeholder xs={12} /></Button></td>
                                <td className="text-center"><Placeholder xs={10} /></td>                                                            
                            </tr>
                            ))}
                        </tbody>
                        ) : (
                        <React.Fragment>                 
                        {Miscellaneous.length > 0 ? (
                        <tbody>
                            {Miscellaneous.map((sm,index)=>(
                            <tr key={index}>
                                <th className="table-success">{appLanguage === 'hi' ? (sm.sm_display_en === "1" ? sm.sm_name_hi || '' : sm.sm_name_hi || sm.sm_name) : sm.sm_name}</th>                                
                                <td className="text-center">{formatDate(sm.sm_date)}</td>
                                <td className="text-center" dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,sm.miscFile,sm.miscFileHi)}} />                           
                            </tr>
                            ))}
                        </tbody>
                        ) : (
                        <tbody>
                            <tr>
                                <td colSpan={3} className='text-center'>{t('NoResult')}</td>
                            </tr>
                        </tbody>
                        )}
                        </React.Fragment>
                        )}
                    </Table>
                </Card.Body>
            </Card>
        </Container>
    );
}
export default Manual;